<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        QAAS LIST
        <v-spacer></v-spacer>
        <v-text-field
          outlined
          dense
          solo
          v-model="search"
          append-icon="fas fa-search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-btn
          v-if="Owners.length"
          icon
          class="d-print-none ml-5"
          small
          color="success"
          @click="PrintPage"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :no-data-text="noData"
          :loading="isLoading"
          :headers="headers"
          :items="Owners"
          :search="search"
        >
          <template v-slot:[`item.more`]="{ item }">
            <base-row-layout>
              <!-- Show Balance Icon -->
              <div>
                <ShowBalance
                  :ReqURL="`${BaseURL}/balance`"
                  :Title="item.FullName"
                  :query="{ AccountNumber: item.AccountNumber }"
                >
                </ShowBalance>
              </div>
              <div>
                <qaas-tran :CustomerID="item">
                  <template v-slot:Ref="{ row: item }">
                    <base-row-layout>
                      <!-- Delte Icon -->
                      <div>
                        <BaseDelete
                          v-if="UsersToken.UserType === 'Admin'"
                          :OnFinish="
                            () => {
                              item.OnSearch(item.fromDate, item.toDate);
                            }
                          "
                          :DelQuery="{ Ref: item.Ref }"
                          DelUrl="/Reports/deleteRef"
                        >
                          <template #title>
                            DELETE
                            <span class="black--text">{{
                              item.Description
                            }}</span>
                          </template>

                          <v-row>
                            <v-col>{{ item.date }}</v-col>

                            <v-col class="black--text" cols="6">{{
                              item.Details
                            }}</v-col>
                            <v-col class="black--text">{{
                              item.Amount && item.Amount.toLocaleString()
                            }}</v-col>
                          </v-row>
                        </BaseDelete>
                      </div>
                      <!-- Edit Icon -->
                      <div>
                        <base-edite-date
                          :Info="item"
                          :BaseURL="BaseURL"
                          :FinishedWithdrow="
                            () => {
                              item.OnSearch(item.fromDate, item.toDate);
                            }
                          "
                        ></base-edite-date>
                      </div>
                    </base-row-layout>
                  </template>
                </qaas-tran>
              </div>
              <!-- Transaction view Icon -->
              <div>
                <OwnerTransaction
                  :BaseURL="BaseURL"
                  queryKey="AccountNumber"
                  :Title="item.FullName"
                  :TranInfo="item"
                >
                  <!-- Qaas Delete Icon -->
                  <template v-slot:Ref="{ row: item }">
                    <base-row-layout>
                      <!-- Delte Icon -->
                      <div>
                        <BaseDelete
                          v-if="UsersToken.UserType === 'Admin'"
                          :OnFinish="
                            () => {
                              item.OnSearch(item.fromDate, item.toDate);
                            }
                          "
                          :DelQuery="{ Ref: item.Ref }"
                          DelUrl="/Reports/deleteRef"
                        >
                          <template #title>
                            DELETE
                            <span class="black--text">{{
                              item.Description
                            }}</span>
                          </template>

                          <v-row>
                            <v-col>{{ item.date }}</v-col>

                            <v-col class="black--text" cols="6">{{
                              item.Details
                            }}</v-col>
                            <v-col class="black--text">{{
                              item.Amount && item.Amount.toLocaleString()
                            }}</v-col>
                          </v-row>
                        </BaseDelete>
                      </div>
                      <!-- Edit Icon -->
                      <div>
                        <base-edite-date
                          :Info="item"
                          :BaseURL="BaseURL"
                          :FinishedWithdrow="
                            () => {
                              item.OnSearch(item.fromDate, item.toDate);
                            }
                          "
                        ></base-edite-date>
                      </div>
                    </base-row-layout>
                  </template>
                </OwnerTransaction>
              </div>
              <!-- More Opteion Icon -->
              <div>
                <more-info :BaseURL="BaseURL" :CustomerID="item"></more-info>
              </div>
            </base-row-layout>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <!-- <p>{{ fab }}</p> -->
        <v-speed-dial bottom left absolute direction="right" v-model="fab">
          <template v-slot:activator>
            <new-qaas
              :BaseURL="BaseURL"
              :loadFunction="loadAllOwners"
            ></new-qaas>
          </template>
        </v-speed-dial>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { printTable } from "@/Mixins/printTable";
import printJS from "print-js";

export default {
  mixins: [printTable],
  components: {
    NewQaas: () => import("@/components/Branches/QAAS/NewQaas.vue"),
    MoreInfo: () => import("@/components/Branches/QAAS/QaasInfro"),
    OwnerTransaction: () => import("@/components/util/TranSactionView.vue"),
    ShowBalance: () => import("@/components/util/showBalance.vue"),
    QaasTran: () => import("./QaasTran"),
  },
  data() {
    return {
      BaseURL: "/qarash/qaas",
      noData: "No Owner is availble",
      fab: false,
      isLoading: true,
      search: "",
      headers: [
        {
          text: "Full Name",
          align: "left",
          value: "FullName",
        },
        { text: "Phone", value: "Qphone" },
        {
          text: "Account",
          value: "AccountNumber",
        },
        // { text: "ID Number", value: "IDNomber", sortable: false },

        {
          text: "More",
          value: "more",
          align: "center",
          sortable: false,
        },
      ],
      Owners: [],
    };
  },

  computed: {
    ...mapGetters(["UsersToken"]),
  },

  methods: {
    PrintPage() {
      // console.log(this.UsersToken.UserBranch);
      let prHeader = [
        { value: "index", text: "#" },
        ...this.headers.filter(
          head =>
            head.text !== "Phone" &&
            head.text !== "More" &&
            head.text !== "Account"
        ),
        {
          value: "Balance",
          text: "Balance",
          width: "170px",
          type: "HTML",
          class: "cellFont",
        },
        { text: "Note", width: "150px" },
      ];
      let myTitle = `${this.UsersToken.UserBranch} qaas`;
      const myPrintTable = this.PrintReport(
        this.Owners.map(exp => ({
          ...exp,
          Balance: exp.EntryBook.reduce((cell, crn) => {
            let pre = document.createElement("pre");

            // pre.className
            let rslt = `${crn.AmountType || ""} =>  ${
              crn && crn.Balance > 0
                ? crn.Balance.toLocaleString()
                : "( " + Math.abs(crn.Balance).toLocaleString() + " )"
            } `;
            pre.textContent = rslt;
            cell.appendChild(pre);
            // console.log(pre);
            // console.log(cell);
            return cell;
          }, document.createDocumentFragment()),
        })).reverse(),
        prHeader,
        myTitle.toUpperCase()
      );

      printJS({
        printable: myPrintTable,
        type: "html",
        style: this.CustomStyle("#f58218", "#ffffff"),
        repeatTableHeader: false,
      });
    },
    loadAllOwners() {
      this.$store
        .dispatch("GET_ONLY", this.BaseURL)
        .then(result => {
          // console.log(result);
          this.Owners = result.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.loadAllOwners();
  },
};
</script>
<style scoped>
.hosdhig {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
